<template>
    <div class="detailed-wrap" @click="hiddenInfo">
        <div class="detailed-l">
            <div class="detailed-head">
                <i class="el-icon-menu"></i>
                <span>皮肤病知识库</span>
            </div>
            <div class="tree-content">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                <div class="tree-content-item">
                    <el-tree
                        class="filter-tree"
                        :data="data"
                        :props="defaultProps"
                        @node-click="getContent"
                        :filter-node-method="filterNode"
                        ref="tree2"
                        style="background:#EBEBEB"
                    ></el-tree>
                </div>
            </div>
        </div>
        <div class="d-right">
            <div class="detailed-head">
                <i class="el-icon-document"></i>
                <span>{{differentContent.spanCon}}</span>
            </div>
            <div class="detailWrapper">
                <div class="leftDetail-list">
                    <div class="imgsCon" style="height:400px;">
                        <div
                            v-bind:style="{ 'border' : index == currentIndex ? '3px solid #48a3c2' : '3px solid #fff'}"
                            v-for="(item,index) in imgList"
                            :key="index"
                            @click="choiceImg(index)"
                            class="imgItem"
                        >
                            <img :src="item" alt style="width: 100%;">
                        </div>
                    </div>
                    <div class="imgAndBtns">
                        <img ref="mimg" :src="imgList[currentIndex]" alt :width="imgWidth" :height="imgHeight">
                        <canvas :width="imgWidth" :height="imgHeight" ref="mcanvas" class="mcanvas"></canvas>
                        <div class="btns"></div>
                    </div>
                </div>
                <div class="d-right-r" v-if="differentContent.showEcharts">
                    <div class="chart">
                        <v-chart :options="polar"/>
                    </div>
                    <div class="chart">
                        <v-chart :options="polar2"/>
                    </div>
                </div>
            </div>
            <div class="similar-con">
                <div class="similar-title">
                    <img>
                    <div class="similar-text">相似图片</div>
                </div>
                <div class="bottomImgs">
                    <div
                        @click="compareImg(index,wordbook[item.disease])"
                        v-for="(item,index) in detail_result[currentIndex].similar"
                        :key="index"
                        class="img-item"
                    >
                        <img
                            :src="apiServer  + '/' + item.path.replace('_case', '_case_thumbnail')"
                            :class="{'isWidth':!item.isWidth,'isHeight':item.isWidth}"
                            alt
                        >
                        <template>
                            <p class="disease_name">{{item.disease_desc}}</p>
                            <p class="disease_name">相似度({{(Number(item.similarity)*100).toFixed(2)}}%)</p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import api from "../api";
  import axios from "axios";
  import ECharts from "vue-echarts";
  import "echarts/lib/chart/line";
  import "echarts/lib/component/polar";
  import csrftoken from "../getToken";
  import raceJson from "../race.js";
  import {checkImage} from "../utils/imageAuto.js";
  
  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    differentContent.spanCon = '以图搜图';
    differentContent.showEcharts = true;
  } else {
    differentContent.spanCon = '以图搜图';
    differentContent.showEcharts = true;
  }
  export default {
    data() {
      return {
        differentContent,
        apiServer: api.server,
        isCompare: false,
        filterText: "",
        data: [],
        defaultProps: {
          children: "children",
          label: "name"
        },
        renderOver: false,
        currentData: [],
        imgList2: [],
        currentIndex: 0,
        showInfo: false,
        showInfoDate: null,
        imgWidth: "",
        imgHeight: "",
        myCanvas: "",
        cxt: "",
        // 当前选择的图片的相似图片数组
        // currentSimilarArr: [],
        polar: {
          title: {
            text: "Top4诊断",
            x: "left",
            y: "10",
            textStyle: {
              fontWeight: "normal",
              color: "#2f2f2f",
              fontSize: "18"
            }
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}"
          },
          color: ["#FCC47C", "#D38165", "#2E4453", "gray", "yellow"],
          legend: {
            // icon: "circle",
            orient: "vertical",
            // itemWidth: 20,
            itemHeight: 10,
            formatter: "{name}",
            x: "16%",
            y: "80%",
            textStyle: {
              color: "#000000",
              width: "10"
            },
            data: []
          },
          calculable: true,
          series: [
            {
              name: "",
              type: "pie",
              radius: "68%", // 饼图的半径大小
              center: ["50%", "40%"], // 饼图的位置
              label: {
                // 饼图图形上的文本标签
                normal: {
                  show: true,
                  position: "inside", // 标签的位置
                  textStyle: {
                    fontWeight: 300,
                    fontSize: 12 // 文字的字体大小
                  },
                  formatter: "{d}%"
                }
              },
              data: []
            }
          ]
        },
        polar2: {
          title: {
            text: "恶性率",
            subtext: "",
            x: "left",
            y:"10",
            textStyle: {
              fontWeight: 'normal',
              color: '#2f2f2f',
              fontSize: '18'
            }
          },
          tooltip: {
            formatter: "{a} <br/>{b} : {c}%"
          },
          series: [
            {
              name: "速度",
              type: "gauge",
              max: 100,
              center: ["50%", "60%"], // 仪表盘位置
              radius: "80%", // 半径
              startAngle: 210, // 起始位置
              endAngle: -30, // 终点位置
              axisLine: {
                // 仪表盘轴线相关配置。
                lineStyle: {
                  color: [
                    [0.2, "green"],
                    [0.4, "#3fa7dc"],
                    [0.6, "yellow"],
                    [0.8, "orange"],
                    [1, "red"]
                  ],
                  width: 16
                }
              },
              splitLine: {
                // 分割线样式
                length: 16,
                lineStyle: {
                  opacity: 0
                }
              },
              axisLabel: {
                formatter: (param) => {
                  // 很低，低，中等，高，很高
                  if (param % 10 === 0) {
                    let newParam;
                    switch (param) {
                      case 10:
                        newParam = "很低";
                        break;
                      case 30:
                        newParam = "低";
                        break;
                      case 50:
                        newParam = "中等";
                        break;
                      case 70:
                        newParam = "高";
                        break;
                      case 90:
                        newParam = "很高";
                        break;
                      default:
                        newParam = "";
                    }
                    return newParam;
                  }
                }
              },
              detail: {
                formatter: (param) => {
                  // 很低，低，中等，高，很高
                  // console.log(param);
                  if (param % 10 === 0) {
                    let newParam;
                    // return param
                    switch (param) {
                      case 10:
                        newParam = "很低";
                        break;
                      case 30:
                        newParam = "低";
                        break;
                      case 50:
                        newParam = "中等";
                        break;
                      case 70:
                        newParam = "高";
                        break;
                      case 90:
                        newParam = "很高";
                        break;
                      default:
                        newParam = "";
                    }
                    return newParam;
                  }
                }
              },
              data: [
                {
                  value: 100,
                  name: " "
                }
              ]
            }
          ]
        },
        showBig: false,
        currentIndex2: 0,
        widthRatio: null,
        heightRatio: null,
        // 当前选择的相似图像
        currentSimilarImg: ""
      };
    },
    props: {
      imgList: {
        type: Array,
        default: () => {
          return [];
        }
      },
      detail_result: {
        type: Array,
        default: () => {
          return [];
        }
      },
      wordbook: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    components: {
      "v-chart": ECharts
    },
    async mounted() {
      let newpath;
      for (let i = 0; i < this.detail_result.length; i++) {
        if (this.detail_result[i].similar) {
          for (let j = 0; j < this.detail_result[i].similar.length; j++) {
            newpath = this.detail_result[i].similar[j].path;
            this.detail_result[i].similar[j].isWidth = await checkImage(
              this.apiServer +
              "/" +
              newpath.replace(
                "_case",
                "_case_thumbnail"
              )
            );
          }
        }
      }
      this.$nextTick(() => {
        this.imgWidth = this.$refs.mimg.width * 1.5;
        this.imgHeight = this.$refs.mimg.height * 1.5;
        const img = new Image();
        img.src = this.imgList[this.currentIndex];
        this.widthRatio = this.imgWidth / img.width;
        this.heightRatio = this.imgHeight / img.height;
        this.myCanvas = this.$refs.mcanvas;
        this.cxt = this.myCanvas.getContext("2d");
        const that = this;
        setTimeout(() => {
          that.cxt.font = "30px";
          that.cxt.fillStyle = "blue";
          that.cxt.clearRect(0, 0, that.imgWidth, that.imgHeight);
          that.cxt.strokeStyle = "blue";
          const coordinate = [];
          const textArr = [];
          
          for (const value of that.detail_result[that.currentIndex].crop) {
            coordinate.push(value.rect.split(","));
            textArr.push(
              that.wordbook[value.result[0].cls_id].name +
              parseInt(value.result[0].prob * 100, 10) +
              "%"
            );
          }
          for (let j = 0; j < coordinate.length; j++) {
            that.cxt.beginPath();
            that.cxt.arc(
              (parseInt(coordinate[j][0], 10) +
                parseInt(coordinate[j][2], 10) / 2) *
              that.widthRatio,
              (parseInt(coordinate[j][1], 10) +
                parseInt(coordinate[j][3], 10) / 2) *
              that.heightRatio,
              (parseInt(coordinate[j][2], 10) / 2) * that.widthRatio,
              0 * Math.PI,
              2 * Math.PI
            );
            that.cxt.stroke();
            that.cxt.closePath();
            that.cxt.fillText(
              textArr[j],
              (parseInt(coordinate[j][0], 10) + 30) * that.widthRatio +
              that.widthRatio,
              (parseInt(coordinate[j][1], 10) +
                parseInt(coordinate[j][3], 10) / 2) *
              that.heightRatio +
              that.heightRatio
            );
          }
          that.renderOver = true;
        }, 80);
      });
      // 模板报告数据
      axios
        .request({
          method: "get",
          url: api.knowledge
        })
        .then(res => {
          this.data = res.data.children;
        });
      let others = 0;
      let colorArr = ["#FCC47C", "#D38165", "#2E4453", "gray", "yellow"]
      this.polar.title.text = this.detail_result[this.currentIndex].result.length > 0 ? 'Top' +
        this.detail_result[this.currentIndex].result.length + '诊断' : '';
      for (let i = 0; i <= this.detail_result[this.currentIndex].result.length; i++) {
        if (this.detail_result[this.currentIndex].result[i]) {
          /*if (
            !!this.wordbook[
              this.detail_result[this.currentIndex].result[i].cls_id
              ]
          ) {
            this.polar.legend.data.push(
              this.wordbook[
                this.detail_result[this.currentIndex].result[i].cls_id
                ].name
            );
            this.polar.series[0].data.push({
              name: this.wordbook[
                this.detail_result[this.currentIndex].result[i].cls_id
                ].name,
              value: this.detail_result[this.currentIndex].result[i].prob,
              itemStyle: {normal: {color: colorArr[i]}}
            });
            others += this.detail_result[this.currentIndex].result[i].prob;
            
            // if (i === 0) {
            //   this.polar.series[0].data.push({
            //     name: this.wordbook[
            //       this.detail_result[this.currentIndex].result[i].cls_id
            //     ].name,
            //     value: this.detail_result[this.currentIndex].result[i].prob,
            //     itemStyle: { normal: { color: "#FCC47C" } }
            //   });
            //   others += this.detail_result[this.currentIndex].result[i].prob;
            // } else if (i === 1) {
            //   this.polar.series[0].data.push({
            //     name: this.wordbook[
            //       this.detail_result[this.currentIndex].result[i].cls_id
            //     ].name,
            //     value: this.detail_result[this.currentIndex].result[i].prob,
            //     itemStyle: { normal: { color: "#D38165" } }
            //   });
            //   others += this.detail_result[this.currentIndex].result[i].prob;
            // } else {
            //   this.polar.series[0].data.push({
            //     name: this.wordbook[
            //       this.detail_result[this.currentIndex].result[i].cls_id
            //     ].name,
            //     value: this.detail_result[this.currentIndex].result[i].prob,
            //     itemStyle: { normal: { color: "#2E4453" } }
            //   });
            // }
            //   others += this.detail_result[this.currentIndex].result[i].prob;
            // console.log(i);
            // console.log(this.detail_result[this.currentIndex].result[i].prob);
          }*/
          this.polar.legend.data.push(this.detail_result[this.currentIndex].result[i].cls_name);
          this.polar.series[0].data.push({
            name: this.detail_result[this.currentIndex].result[i].cls_name,
            value: this.detail_result[this.currentIndex].result[i].prob,
          })
        }
      }
      
      /*this.polar.series[0].data.push({
        name: "其他",
        value: 1 - others,
        itemStyle: {normal: {color: "#C0B3BC"}}
      });
      this.polar.legend.data.push({
        name: "其他",
        value: 1 - others,
        itemStyle: {normal: {color: "#C0B3BC"}}
      });*/
      
      // console.log(this.polar.series[0].data);
      /*for (let i = 0; i < 2; i++) {
        if (i === 0) {
          this.polar2.series[0].data.push({
            name: "恶性",
            value: this.detail_result[this.currentIndex].malignant_prob,
            itemStyle: {normal: {color: "#C13430"}}
          });
        } else {
          this.polar2.series[0].data.push({
            name: "良性",
            value: 1 - this.detail_result[this.currentIndex].malignant_prob,
            itemStyle: {normal: {color: "#FBC57F"}}
          });
        }
      }*/
      if (this.detail_result[this.currentIndex].malignant_prob) {
        this.polar2.series[0].data[0].value = (this.detail_result[this.currentIndex].malignant_prob* 20)-10;
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree2.filter(val);
      }
    },
    methods: {
      // 递归的将病名前的数组去除
      dealDiseaseName(obj) {
        if (obj.hasOwnProperty("children")) {
          let c = obj.children;
          for (let i = 0; i < c.length; i++) {
            c[i].name = c[i].name.replace(/^[0-9]+-/, "");
            this.dealDiseaseName(c[i]);
          }
        } else {
          obj.name = obj.name.replace(/^[0-9]+-/, "");
        }
      },
      filterNode(value, data) {
        if (!value) {
          return true;
        }
        return data.name.indexOf(value) !== -1;
      },
      getContent() {
        this.currentData = this.$refs.tree2.getCurrentNode();
        if (this.showInfo) {
          this.showInfo = false;
        }
        if (this.currentData.images) {
          for (let i = 0; i < this.currentData.images.length; i++) {
            this.imgList2[i] =
              api.knowledgeUrl + "/" + this.currentData.images[i];
          }
        } else {
          this.imgList2 = [];
        }
        if (!this.currentData.children) {
          this.showInfo = true;
          this.showInfoDate = this.currentData;
        }
      },
      choiceImg(num) {
        this.currentIndex = num;
        const img = new Image();
        img.src = this.imgList[num];
        this.widthRatio = this.imgWidth / img.width;
        this.heightRatio = this.imgHeight / img.height;
        // this.cxt.font = "30px";
        this.cxt.fillStyle = "blue";
        this.cxt.clearRect(0, 0, this.imgWidth, this.imgHeight);
        this.cxt.strokeStyle = "blue";
        const coordinate = [];
        const textArr = [];
        for (const value of this.detail_result[this.currentIndex].crop) {
          coordinate.push(value.rect.split(","));
          textArr.push(
            this.wordbook[value.result[0].cls_id].name +
            parseInt(value.result[0].prob * 100, 10) +
            "%"
          );
        }
        for (let j = 0; j < coordinate.length; j++) {
          this.cxt.beginPath();
          this.cxt.arc(
            (parseInt(coordinate[j][0], 10) +
              parseInt(coordinate[j][2], 10) / 2) *
            this.widthRatio,
            (parseInt(coordinate[j][1], 10) +
              parseInt(coordinate[j][3], 10) / 2) *
            this.heightRatio,
            (parseInt(coordinate[j][2], 10) / 2) * this.widthRatio,
            0 * Math.PI,
            2 * Math.PI
          );
          this.cxt.stroke();
          this.cxt.closePath();
          this.cxt.fillText(
            textArr[j],
            (parseInt(coordinate[j][0], 10) + 30) * this.widthRatio,
            (parseInt(coordinate[j][1], 10) +
              parseInt(coordinate[j][3], 10) / 2) *
            this.heightRatio
          );
        }
        this.polar.legend.data = [];
        this.polar.series[0].data = [];
        let others = 0;
        // console.log(this.detail_result[this.currentIndex].result)
        let colorArr = ["#FCC47C", "#D38165", "#2E4453", "gray", "yellow"]
        this.polar.title.text = this.detail_result[this.currentIndex].result.length > 0 ? 'Top' +
          this.detail_result[this.currentIndex].result.length + '诊断': '';
        for (let i = 0; i <= this.detail_result[this.currentIndex].result.length; i++) {
          
          
          if (this.detail_result[this.currentIndex].result[i]) {
            /*if (
              !!this.wordbook[
                this.detail_result[this.currentIndex].result[i].cls_id
                ]
            ) {
              
              
              this.polar.legend.data.push(
                this.wordbook[this.detail_result[this.currentIndex].result[i].cls_id]
                  .name
              );
              // console.log(this.detail_result[this.currentIndex].result[i].prob)
              this.polar.series[0].data.push({
                name: this.wordbook[
                  this.detail_result[this.currentIndex].result[i].cls_id
                  ].name,
                value: this.detail_result[this.currentIndex].result[i].prob,
                itemStyle: {normal: {color: colorArr[i]}}
              });
              others += this.detail_result[this.currentIndex].result[i].prob;
              
            }*/
            this.polar.legend.data.push(this.detail_result[this.currentIndex].result[i].cls_name);
            this.polar.series[0].data.push({
              name: this.detail_result[this.currentIndex].result[i].cls_name,
              value: this.detail_result[this.currentIndex].result[i].prob,
            })
          }
          
          // if (i === 0) {
          //   this.polar.series[0].data.push({
          //     name: this.wordbook[
          //       this.detail_result[this.currentIndex].result[i].cls_id
          //     ].name,
          //     value: this.detail_result[this.currentIndex].result[i].prob,
          //     itemStyle: { normal: { color: "#FCC47C" } }
          //   });
          // } else if (i === 1) {
          //   this.polar.series[0].data.push({
          //     name: this.wordbook[
          //       this.detail_result[this.currentIndex].result[i].cls_id
          //     ].name,
          //     value: this.detail_result[this.currentIndex].result[i].prob,
          //     itemStyle: { normal: { color: "#D38165" } }
          //   });
          // } else {
          //   this.polar.series[0].data.push({
          //     name: this.wordbook[
          //       this.detail_result[this.currentIndex].result[i].cls_id
          //     ].name,
          //     value: this.detail_result[this.currentIndex].result[i].prob,
          //     itemStyle: { normal: { color: "#2E4453" } }
          //   });
          
          // }
          
        }
        /*this.polar.series[0].data.push({
          name: "其他",
          value: 1 - others,
          itemStyle: {normal: {color: "#C0B3BC"}}
        });
        this.polar.legend.data.push({
          name: "其他",
          value: 1 - others,
          itemStyle: {normal: {color: "#C0B3BC"}}
        });*/
        // this.polar2.series[0].data = [];
        
        /*for (let i = 0; i < 2; i++) {
          if (i === 0) {
            this.polar2.series[0].data.push({
              name: "恶性",
              value: this.detail_result[this.currentIndex].malignant_prob,
              itemStyle: {normal: {color: "#C13430"}}
            });
          } else {
            this.polar2.series[0].data.push({
              name: "良性",
              value: 1 - this.detail_result[this.currentIndex].malignant_prob,
              itemStyle: {normal: {color: "#FBC57F"}}
            });
          }
        }*/
        if (this.detail_result[this.currentIndex].malignant_prob) {
          this.polar2.series[0].data[0].value = (this.detail_result[this.currentIndex].malignant_prob* 20)-10;
        }
      },
      showBigImg(num) {
        this.currentIndex2 = num;
        this.showBig = true;
      },
      closeBig() {
        this.showBig = false;
      },
      // 显示比较图片
      async compareImg(index) {
        this.$store.commit("setSimilarImg", "ss");
        this.isCompare = true;
        this.currentSimilarImg =
          api.server +
          "/" +
          this.detail_result[this.currentIndex].similar[index].path;
        let isWidth1 = await checkImage(this.imgList[this.currentIndex]);
        let isWidth2 = await checkImage(this.currentSimilarImg);
        let similarity = this.detail_result[this.currentIndex].similar[index]
          .similarity;
        let disease_desc = this.detail_result[this.currentIndex].similar[index]
          .disease_desc;
        this.$emit("compare", {
          type: "compare",
          choosedImg: this.imgList[this.currentIndex],
          compareImg: this.currentSimilarImg,
          isWidth1,
          isWidth2,
          similarity,
          disease_desc
        });
      },
      hiddenInfo() {
        this.showInfo = false;
      }
    }
  };
</script>
<style scoped lang="less">
    /*::-webkit-scrollbar {*/
    /*width: 5px;*/
    /*height: 100%;*/
    /*}*/
    /*::-webkit-scrollbar-track-piece {*/
    /*background: #fff;*/
    /*-webkit-border-radius: 6px;*/
    /*}*/
    /*::-webkit-scrollbar-thumb:vertical {*/
    /*background-color: #61a2bf;*/
    /*-webkit-border-radius: 6px;*/
    /*}*/
    .detailed-wrap {
        width: 88%;
        min-width: 1300px;
        margin: 0 auto;
        height: 88%;
        margin-top: 3%;
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #48a3c2;
    }
    
    // .detailed-wrap {
    // }
    .similarDialog {
        .el-dialog--center {
            height: 65vh;
            background: #ebebeb;
            border-radius: 2vh;
            
            .el-dialog__title {
                color: #61a2bf;
            }
        }
    }
    
    .detailed-head {
        color: #48a3c2;
        font-size: 24px;
        padding: 5px 10px;
        border-bottom: 1px solid #48a3c2;
        margin-bottom: 10px;
    }
    
    .detailed-l {
        width: 25%;
        height: 100%;
        background: #ebebeb;
        float: left;
        overflow-x: hidden;
        overflow-y: hidden;
        padding: 0 10px;
        box-sizing: border-box;
        
        .tree-content {
            height: calc(~"100% - 36px");
            
            .tree-content-item {
                height: 50%;
                overflow-y: auto;
            }
        }
    }
    
    .detailWrapper,
    .leftDetail-list,
    .echarts-con,
    .similar-con,
    .similar-title,
    .bottomImgs,
    .canvas-img,
    .imgsCon,
    .btns,
    .imgAndBtns,
    .imgWrapper {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: nowrap;
    }
    
    .imgWrapper {
        align-items: flex-start;
        justify-content: space-between;
        font-size: 1.5rem;
        margin-top: 10vh;
        color: #48a3c2;
        
        .chooseImgCon {
            flex: 1;
            text-align: center;
            
            .cs-text {
                margin-bottom: 2vh;
            }
        }
    }
    
    .d-right {
        width: 75%;
        height: 100%;
        float: left;
        
        .detailWrapper {
            width: 100%;
            height: 50%;
            // align-items: flex-start;
            .leftDetail-list {
                width: 50%;
                // flex:15;
                flex-direction: row;
                
                .imgsCon {
                    flex-direction: column;
                    align-items: center;
                    flex-basis: 200px;
                    overflow-y: auto;
                    padding: 0px 1%;
                    
                    .imgItem {
                        position: relative;
                        margin-bottom: 5%;
                    }
                }
                
                .imgAndBtns {
                    margin-left: 4%;
                    align-items: center;
                    flex-direction: column;
                    position: relative;
                    
                    .mcanvas {
                        position: absolute;
                        top: 0px;
                        left: 0px;
                    }
                }
                
                .btns {
                    margin-top: 10%;
                }
            }
            
            .rightDetail-list {
                width: 50%;
                
                .echarts-con {
                    width: 40%;
                }
            }
        }
        
        .similar-con {
            width: 100%;
            flex-direction: column;
            height: calc(~"100% - 463px");
            
            .similar-title {
                flex-wrap: wrap;
                justify-content: flex-start;
                margin-left: 2%;
                padding: 1% 2%;
                border-bottom: 1px solid #48a3c2;
                width: 92%;
                max-height: 37px;
            }
            
            .bottomImgs {
                height: calc(~"100% - 37px");
                padding: 16px 10px 0;
                justify-content: flex-start;
                overflow-y: auto;
                flex-wrap: wrap;
                
                .img-item {
                    margin-right: 10px;
                    cursor: pointer;
                }
                
                // .img-item:nth-child(5n) {
                //   margin-right: 0px;
                // }
            }
        }
    }
    
    .detailed-c {
        width: 14%;
        height: 50%;
        padding: 10px;
        float: left;
        overflow-x: hidden;
        overflow-y: scroll;
    }
    
    .detailed-l::-webkit-scrollbar,
    .detailed-c::-webkit-scrollbar {
        display: none;
    }
    
    .detailed-r {
        width: 84%;
        height: 91%;
        border-left: 1px solid #48a3c2;
        float: left;
        text-align: center;
        background: #ebebeb;
    }
    
    .canvas-img img,
    .canvas-img canvas {
        position: absolute;
        top: 5px;
        left: 5px;
    }
    
    .d-right-l {
        width: 74%;
        position: relative;
        height: 100%;
        overflow: hidden;
        float: left;
    }
    
    .d-right-r {
        display: flex;
        flex-direction: row;
        width: 50%;
        height: 100%;
        // margin-left: 13%;
        margin-top: 20px;
    }
    
    .d-right-r .chart {
        width: 100%;
        height: 100%;
    }
    
    .similar-img {
        width: 100%;
        height: 23%;
        position: absolute;
        bottom: 0;
        left: 0;
    }
    
    .similar-img h3 {
        width: 8%;
        height: 70%;
        color: #48a3c2;
        margin: 6% 10px;
        float: left;
    }
    
    .img-content {
        width: 88%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
        float: left;
    }
    
    .canvas-img {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
    }
    
    .canvas-img {
        width: 60%;
        height: 60%;
        position: relative;
        overflow: hidden;
    }
    
    .canvas-img img {
        width: 100%;
        height: 100%;
    }
    
    .img-item {
        // width: 23%;
        // height: 90%;
        float: left;
        overflow: hidden;
        margin-right: 10px;
        padding-bottom: 16px;
        box-sizing: border-box;
    }
    
    .img-item img {
        width: 100%;
        height: 100%;
    }
    
    .detailed-r canvas {
        z-index: 999;
    }
    
    .detailed-c div {
        width: 82%;
        height: auto;
        margin: 10px auto;
        padding: 5px;
        overflow: hidden;
        border-radius: 10px;
        box-sizing: border-box;
    }
    
    .detailed-c div img {
        width: 100%;
        height: 100%;
    }
    
    .active {
        border: 3px solid #48a3c2;
    }
    
    .result-info {
        width: 310px;
        height: 260px;
        background: #fff;
        border: 1px solid #48a3c2;
        border-radius: 10px;
        position: fixed;
        bottom: 10px;
        left: 33px;
        padding: 10px;
        box-sizing: border-box;
    }
    
    .big-img {
        width: 540px;
        height: 390px;
        position: fixed;
        bottom: 10px;
        left: 33px;
        z-index: 999;
        background: #fff;
        padding: 20px;
        border-radius: 10px;
        overflow: hidden;
    }
    
    .big-img img {
        width: 100%;
        height: 100%;
    }
    
    .img-box img {
        width: 140px;
        height: 140px;
    }
    
    h4,
    h3 {
        margin: 0;
    }
    
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }
    
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    
    .echarts {
        width: 100%;
        height: 100%;
    }
    
    .btn-theme {
        background: #48a3c2 !important;
        border: 0px;
    }
    
    .isWidth {
        width: 160px !important;
        height: auto !important;
    }
    
    .isHeight {
        height: 160px !important;
        width: auto !important;
    }
    
    .disease_name {
        font-size: 12px !important;
        text-align: center !important;
        color: #48a3c2 !important;
    }
</style>

